import React from "react";
import { isDesktop } from "react-device-detect";
import ColorPicker from "./colorPicker";
import PaintBrush from "./paintBrush";
import Tippy from "@tippyjs/react";

const NavInfoSemesterCollapsed = ({ updateColor, color }) => {

    return (
        <>
            <div className="semester-nav-info" style={{ marginTop: "190px", alignItems: "flex-end" }}>
                {
                    isDesktop

                    ?

                        <>                            
                            <Tippy content={"Choose Color"} placement={"right"}>                  
                                <div className="collapsed" style={{ marginRight: "-5.5px" }}>                               
                                    <ColorPicker color={color} updateColor={updateColor} collapsed={true}/>
                                </div>
                            </Tippy>

                            <Tippy content={"Drag And Drop Color"} placement={"right"}>  
                                <div className="collapsed" style={{ marginRight: "-10px" }}>
                                    <PaintBrush color={color} />
                                </div>
                            </Tippy>
                        </>

                    :

                        <>
                        </>

                }
            </div>
        </>
    );
}

export default NavInfoSemesterCollapsed;